import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const homeFor = (user) => (user.role === "admin" ? "/admin" : user.role === "employee" ? "/new-job" : "/portal");

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Returning from Google sign-in: AuthCallback exchanges the session first.
    if (window.location.hash?.includes("session_id=")) {
      setUser(false);
      return;
    }
    if (!localStorage.getItem("ct_token")) {
      setUser(false);
      return;
    }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem("ct_token");
      setUser(false);
    });
  }, []);

  const finish = (data) => {
    localStorage.setItem("ct_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => finish((await api.post("/auth/login", { email, password })).data);

  const loginWithSession = useCallback(
    async (sessionId) => finish((await api.post("/auth/session", { session_id: sessionId })).data),
    []
  );

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("ct_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, loginWithSession, logout }}>{children}</AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
